import React from 'react';
import {useFilter} from "../Contexts/FilterContext"

function FilterEventToggle(props) {
    const filter = useFilter()
    function handleChange(event) {
      const {name, value, type, checked} = event.target
      filter.setFilterData(prevFilterData => {
          return {
              ...prevFilterData,
              [name]: type === "checkbox" ? checked : value
          }
      })
    }

    function handleSubmit(event) {
      let data = props.data
      if (filter.filterData.filterDate != "") {
        data = JSON.parse(JSON.stringify(data)).filter((event) => (event.date === filter.filterData.filterDate))
      } 
      if (filter.filterData.filterTime != "") {
        data = JSON.parse(JSON.stringify(data)).filter((event) => (event.time === filter.filterData.filterTime))
      } 
      if (filter.filterData.filterInviteOnly != false) {
        data = JSON.parse(JSON.stringify(data)).filter((event) => (event.inviteOnly === "false"))
      }
      return filter.setFilter(data)
    }

        return (
            <div>
                <div className="flex w-[100%] mb-[10px]">
                  <p className="mt-0 text-[17px] py-[10px] font-light text-gray-900">Filter by: </p>
                    <input className="bg-white drop-shadow-sm h-8 my-[5px] pl-[10px] mx-[8px]"
                        type="text"
                        placeholder="Date"
                        onChange={handleChange}
                        name="filterDate"
                        value={filter.filterData.filterDate}
                    />
                    <input className="bg-white drop-shadow-sm h-8 my-[5px] pl-[10px] mx-[8px]"
                        type="text"
                        placeholder="Time"
                        onChange={handleChange}
                        name="filterTime"
                        value={filter.filterData.filterTime}
                    />
                    <input className="mr-[5px]"
                        type="checkbox" 
                        id="filterInviteOnly" 
                        checked={filter.filterData.filterInviteOnly}
                        onChange={handleChange}
                        name="filterInviteOnly"
                    />
                    <label className="text-[15px] my-[12px] font-light mr-[15px] text-gray-50" htmlFor="filterInviteOnly">Remove Invite Only</label>
                    <button className="rounded-sm px-2 border-[1px] border-black bg-white hover:bg-black text-black hover:text-white mr-[5px] my-[10px] font-normal" onClick={handleSubmit} >Filter</button>
                </div>
            </div>
        )
}

export default FilterEventToggle;